import { configureStore, combineReducers } from '@reduxjs/toolkit';
import reportsReducer from './slices/ReportsSlice';
import toolsReducer from './slices/ToolsSlice';
import profileReducer from './slices/ProfileSlice';
import { baseApi } from '@/api/rtk/baseApi';
import '@/api/rtk/userApi';
import '@/api/rtk/toolsApi';
import '@/api/rtk/reportsApi';
import '@/api/rtk/profileApi';
import '@/api/rtk/mutationsApi';
import { injectStore } from '@/api/rtk/runEndpoint';

const appReducer = combineReducers({
  reportsSlice: reportsReducer,
  toolsSlice: toolsReducer,
  profileSlice: profileReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

injectStore(store);
